"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopsoilContract = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const ResourceType_1 = require("../../ResourceType");
const Resources_1 = require("../../Resources");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
class TopsoilContract extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.TOPSOIL_CONTRACT,
            tags: [Tags_1.Tags.MICROBE, Tags_1.Tags.EARTH],
            cost: 8,
            metadata: {
                cardNumber: 'X30',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.effect('When you gain a microbe to ANY CARD, gain 1 M€.', (eb) => {
                        eb.microbes(1).asterix().startEffect.megacredits(1);
                    }).br;
                    b.plants(3);
                }),
                description: 'Gain 3 plants.',
            },
        });
    }
    play(player) {
        player.plants += 3;
        return undefined;
    }
    static onResourceAdded(player, card, count) {
        if (card.resourceType === ResourceType_1.ResourceType.MICROBE && player.cardIsInEffect(CardName_1.CardName.TOPSOIL_CONTRACT)) {
            player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
                player.addResource(Resources_1.Resources.MEGACREDITS, count, { log: true });
                return undefined;
            }), DeferredAction_1.Priority.GAIN_RESOURCE_OR_PRODUCTION);
        }
    }
}
exports.TopsoilContract = TopsoilContract;
//# sourceMappingURL=TopsoilContract.js.map